import { useState } from "react";
import DeviceForm from "./form";
import { useNavigate } from "react-router-dom";
import Modal from "../../../../../components/Common/Modal";
import { useDeviceRegistrationStatus } from "../../../../../common/hooks/api/device";
import Spinner from "../../../../../components/Common/Spinner";

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

const DeviceFormModal = ({
    isOpen,
    onClose,
}: Props) => {
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [deviceSerialNumber, setDeviceSerialNumber] = useState('');

    const { isLoading: isRegistrationStatusLoading } = useDeviceRegistrationStatus(deviceSerialNumber, {
        enabled: !!deviceSerialNumber,
        onSuccess: ({ data }) => {
            console.log('Payload (response.data):', data);
            if (data?.status === 'Registered') {
                setError('This machine is already registered');
            }
            else if (data?.status === 'InvalidSerial') {
                setError('This Serial Number is invalid');
            }
            // TODO: BE was changed - align this case with invalid number
            /* else if (!data?.device) {
                setError('The serial number you have entered is invalid');
            }*/ else {
                onClose();
                navigate(`${deviceSerialNumber}/warranty-registration`);
            }
        },
    });

    const onSaveDevice = (values: any): void => {
        setError('');
        setDeviceSerialNumber(values.name);
    };

    
    return (
        <Modal isOpen={isOpen} onToggle={onClose} title="Register Machine">
        {/* Spinner overlay container—same approach used on DeviceWarrantyRegistrationPage */}
        <div
            className="position-relative"
            style={{
            minHeight: "200px", // ensure there’s enough space to center the spinner in the modal content
            }}
        >
            {isRegistrationStatusLoading && (
            <div style={{ position: "absolute", inset: 0, zIndex: 1000 }}>
                <Spinner />
            </div>
            )}

            <DeviceForm
            onSubmit={onSaveDevice}
            isSaving={isRegistrationStatusLoading} // still useful if the form shows inline loading
            error={error}
            />
        </div>
        </Modal>
    );
};


export default DeviceFormModal;
